import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import Styles from './RightColumnContainer.module.scss'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import { RootState } from 'types'
import { isEqual } from 'lodash'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  className?: string
}>

export const RightColumnContainer = observer(({ children, className }: Props) => {
  const layout = useLayout()
  const { showFocusMode } = useSelector(({ focusMode }: RootState) => focusMode, isEqual)
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return null
  }

  return (
    <div
      className={cx(Styles.container, className, {
        [Styles.focusMode]: showFocusMode,
        [Styles.locked]: layout.rightColumnLocked && !isMobile,
      })}
      ref={(node) => layout.setRightColumn(node)}
    >
      {children}
    </div>
  )
})
